import React, { Component } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { t } from 'services/translation';
import { FormattedMessage } from 'react-intl';

import { Theme, Wrapper, Label, SubLabel, ButtonLink } from '../styles';

const Body = styled('div')`
  padding: 50px;
  max-width: 768px;
  margin: 0 auto;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const HR = styled('div')`
  height: 1px;
  width: 100px;
  background: ${Theme.colors.lightLine};
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const ReviewButtons = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    flex-direction: column;
    margin-top: 15px;
  }
`;

const Button = styled(ButtonLink)`
  margin: 10px;
  width: 100%;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    max-width: 300px;
  }
  max-width: 250px;
`;

const SocialButtons = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
`;

const SocialButton = styled(Button)`
  padding: 5px 8px 5px 8px;
  font-size: 14px;
  margin: 5px auto;
  width: unset;
`;

const Footer = styled('div')`
  width: 100%;
  text-align: center;
  background: ${Theme.colors.lightBackground};
  color: ${Theme.colors.lightText};

  span {
    font-weight: 600;
  }

  padding: 40px 20px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

class ThankYou extends Component {
  // Only renders for positive brand impact (score >= 7)
  renderExtra = () => {
    const { brand, settings, feedback } = this.props;
    const { score } = feedback.attributes;
    const { tripadvisor, yelp, google } = settings.reviewButtons;

    if (score < 7) return null;
    if (!tripadvisor && !yelp && !google) return null;

    // Review Buttons setup
    const delegateUrl = `/tya/feedback/${feedback.id}/delegate`;
    const linkProps = {
      backgroundColor: brand.buttonBackgroundColor,
      target: '_blank',
      rel: 'noopener noreferrer',
    };
    let tripAdvisorButton = null;
    let yelpButton = null;
    let googleButton = null;

    if (tripadvisor) {
      tripAdvisorButton = (
        <Button {...linkProps} href={`${delegateUrl}?platform=tripadvisor`}>
          TripAdvisor
        </Button>
      );
    }
    if (yelp) {
      yelpButton = (
        <Button {...linkProps} href={`${delegateUrl}?platform=yelp`}>
          Yelp
        </Button>
      );
    }
    if (google) {
      googleButton = (
        <Button {...linkProps} href={`${delegateUrl}?platform=google`}>
          Google
        </Button>
      );
    }

    return (
      <div>
        <HR />
        <SubLabel
          css={css`
            color: ${Theme.colors.black};
          `}
        >
          {t('OUR_BUSINESS_DEPENDS_ON_HAPPY_CUSTOMERS')}.{' '}
          {t(
            'WE_WOULD_REALLY_APPRECIATE_IF_YOU_COULD_TAKE_A_MINUTE_TO_REVIEW_US_ON_THE_SITE_OF_YOUR_CHOICE'
          )}
          .
        </SubLabel>
        <ReviewButtons>
          {tripAdvisorButton}
          {yelpButton}
          {googleButton}
        </ReviewButtons>
      </div>
    );
  };

  renderFooter = () => {
    const { feedback, settings } = this.props;
    const { score } = feedback.attributes;
    const { facebook, instagram, twitter } = settings.socialButtons;

    if (score < 7) return null;
    if (!facebook && !instagram && !twitter) return null;

    // Social Buttons setup
    const delegateUrl = `/tya/feedback/${feedback.id}/delegate`;
    let facebookButton = null;
    let instagramButton = null;
    let twitterButton = null;

    if (facebook) {
      facebookButton = (
        <SocialButton
          backgroundColor="#4267B2"
          target="_blank"
          rel="noopener noreferrer"
          href={`${delegateUrl}/?platform=facebook`}
        >
          <i className="ion-social-facebook" />
          Like
        </SocialButton>
      );
    }

    if (instagram) {
      instagramButton = (
        <SocialButton
          backgroundColor="#6F97B6"
          target="_blank"
          rel="noopener noreferrer"
          href={`${delegateUrl}/?platform=instagram`}
        >
          <i className="ion-social-instagram-outline" />
          {t('FOLLOW')}
        </SocialButton>
      );
    }

    if (twitter) {
      twitterButton = (
        <SocialButton
          backgroundColor="#1B95E0"
          target="_blank"
          rel="noopener noreferrer"
          href={`${delegateUrl}/?platform=twitter`}
        >
          <i className="ion-social-twitter" />
          {t('FOLLOW')}
        </SocialButton>
      );
    }

    return (
      <Footer>
        <span style={{ whiteSpace: 'pre-line' }}>
          <FormattedMessage
            id="STAY_IN_TOUCH"
            defaultMessage={`Stay in touch\n\nAnd be the first to know about new products, special events, and promotions`}
          />
        </span>
        <SocialButtons>
          {facebookButton}
          {instagramButton}
          {twitterButton}
        </SocialButtons>
      </Footer>
    );
  };

  render() {
    return (
      <Wrapper>
        <Body>
          <Label>{t('THANK_YOU')}!</Label>
          <Label>{t('YOUR_FEEDBACK_IS_VERY_VALUABLE_TO_US')}.</Label>
          {this.renderExtra()}
        </Body>
        {this.renderFooter()}
      </Wrapper>
    );
  }
}

export default ThankYou;
